import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-account-number-dialog',
    templateUrl: './account-number-dialog.component.html',
    standalone: false
})
export class AccountNumberDialogComponent {
  @Input() title: string = 'App.AccountNumber.Labels.AccountNumber';

  constructor(
    private dialogRef: MatDialogRef<AccountNumberDialogComponent>,
  ) {
    this.dialogRef.addPanelClass('dialog');
    this.dialogRef.updateSize('600px', 'auto');
  }

  closeDialog() {
    this.dialogRef.close();
  }
}